import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';

import { vimeoIdFrom } from '@Helpers/vimeo-video';

export class Eleven extends Lit3formBlock {
  static get characterName() {
    return 'eleven';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid eleven-layout">
          ${this.mediaHTML} ${this.captionHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get mediaHTML() {
    return this.videoId
      ? html`
          <div class="eleven-media eleven-video">
            <vimeo-video
              videoid="${this.videoId}"
              videoWidth="1200"
              fitaspect
            ></vimeo-video>
          </div>
        `
      : html`
          <div class="eleven-media eleven-image">
            <img src="${this.imageUrl}" />
          </div>
        `;
  }

  get captionHTML() {
    return this.caption
      ? html`
          <div class="eleven-caption">
            <p>${unsafeHTML(this.caption)}</p>
          </div>
        `
      : html``;
  }

  get caption() {
    return this.content.image?.description
      ? this.withLineBreaks(this.content.image.description)
      : '';
  }

  get videoId() {
    return vimeoIdFrom(this.content.video_url);
  }

  get imageUrl() {
    // Width only — height would crop. Maximum height is handled in CSS.
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, 1200)
      : '';
  }
}
Eleven.defineElement();
